'use client';

import type { Course } from '@eliadmin/core/src/api/courses/coursers-api';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function CourseLevel({ course }: { course: Course }) {
  return (
    <div className="flex items-center justify-start gap-2">
      {course.levels?.map(course => (
        <span
          key={course.name}
          className={cn(
            'px-1.5 py-[4px] text-[10px] font-bold uppercase sm:text-xs md:px-2 md:py-0.5 md:text-sm',
            course?.id === 1 && 'bg-neutral-200 text-black',
            course?.id === 2 && 'bg-black text-white',
            course?.id === 3 && 'bg-primary text-white',
          )}
        >
          {course?.name}
        </span>
      ))}
    </div>
  );
}
